export default __webpack_public_path__ + "static/icon-28-4-6df0572e276faac4d9560d365b3ea465.png";